(() => {
  const initialize = root => {
    root.querySelectorAll('.okhomes-team__form-panel').forEach(panel => {
      if (panel.dataset.fallbackReady) return;
      panel.dataset.fallbackReady = 'true';
      const fallback = panel.querySelector('[data-okhomes-team-fallback]');
      const appBlocks = Array.from(panel.querySelectorAll('.shopify-app-block'));
      if (!fallback || !appBlocks.length) return;
      const observed = new WeakSet();
      const observer = new MutationObserver(refreshFallback);
      function hasFields(node) {
        if (!observed.has(node)) {
          observer.observe(node, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'style', 'class'] });
          observed.add(node);
        }
        if (Array.from(node.querySelectorAll('input:not([type="hidden"]), select, textarea')).some(field => field.getClientRects().length > 0)) return true;
        return Array.from(node.querySelectorAll('*')).some(element => element.shadowRoot && hasFields(element.shadowRoot));
      }
      function refreshFallback() {
        fallback.hidden = appBlocks.some(hasFields);
      }
      refreshFallback();
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(panel)) observer.disconnect();
      }, { once: true });
    });
    root.querySelectorAll('[data-okhomes-team-form]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const summary = form.querySelector('[data-team-summary]');
      form.addEventListener('submit', event => {
        event.preventDefault();
        if (!form.reportValidity()) return;
        const lines = Array.from(form.querySelectorAll('[data-label]')).filter(field => field.type !== 'checkbox' || field.checked).map(field => field.dataset.label + ': ' + field.value);
        summary.value = form.dataset.subject + '\n\n' + lines.join('\n') + '\n\nOrigen: OKHOMES · ' + window.location.pathname + window.location.search;
        form.querySelector('[data-team-prepared]').hidden = false;
        window.location.href = 'mailto:' + form.dataset.recipient + '?subject=' + encodeURIComponent(form.dataset.subject) + '&body=' + encodeURIComponent(summary.value);
      });
      form.querySelector('[data-team-copy]').addEventListener('click', async event => {
        const copiedMessage = event.currentTarget.dataset.copied;
        try {
          await navigator.clipboard.writeText(summary.value);
          form.querySelector('[data-team-copy-status]').textContent = event.currentTarget.dataset.copied;
        } catch {
          summary.focus();
          summary.select();
        }
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
